import { Route } from 'react-router';
import ProtectedRoutes from '../components/ProtectedRoutes';
import { lazyRoute } from './lazyRoute';

export const renderAccountRoutes = () => (
  <Route path="account" element={<ProtectedRoutes />}>
    <Route
      index
      element={lazyRoute(() => import('@betty/account/pages/AccountPage'))}
    />
    <Route
      path="details"
      element={lazyRoute(() => import('@betty/account/pages/MyProfilePage'))}
    />

    <Route
      path="payment-history"
      element={lazyRoute(
        () => import('@betty/account/pages/TransactionHistoryPage'),
      )}
    />
    <Route
      path="game-transactions"
      element={lazyRoute(
        () => import('@betty/account/pages/GamingHistoryPage'),
      )}
    />
    <Route
      path="coins-game-transactions"
      element={lazyRoute(
        () => import('@betty/account/pages/CoinsGamingTransactionsPage'),
      )}
    />
    <Route
      path="sessions"
      element={lazyRoute(
        () => import('@betty/account/pages/SessionHistoryPage'),
      )}
    />
    <Route path="limits">
      <Route
        index
        element={lazyRoute(
          () => import('@betty/account/pages/ResponsibleGamingPage'),
        )}
      />
      <Route
        path="deposit"
        element={lazyRoute(
          () => import('@betty/account/pages/DepositLimitPage'),
        )}
      />
      <Route
        path="loss"
        element={lazyRoute(() => import('@betty/account/pages/LossLimitPage'))}
      />
      <Route
        path="playtime"
        element={lazyRoute(
          () => import('@betty/account/pages/PlaytimeLimitPage'),
        )}
      />
      <Route
        path="timeout"
        element={lazyRoute(() => import('@betty/account/pages/TimeoutPage'))}
      />
      <Route path="self-exclusion">
        <Route
          index
          element={lazyRoute(
            () => import('@betty/account/pages/SelfExclusionPage'),
          )}
        />
        <Route
          path="verify"
          element={lazyRoute(
            () => import('@betty/account/pages/SelfExclusionVerifyPage'),
          )}
        />
      </Route>
    </Route>
    <Route
      path="source-of-funds"
      element={lazyRoute(
        () => import('@betty/account/pages/SOFAttestationPage'),
      )}
    />
  </Route>
);
